import { Quote, TrendingUp } from "lucide-react";
import { Reveal } from "./Reveal";
import { TESTIMONIALS } from "../../data/content";

export const Testimonials = () => (
  <section data-testid="testimonials-section" className="py-24 sm:py-32 bg-secondary/30">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <p className="text-xs uppercase font-mono tracking-[0.28em] text-emerald-600 dark:text-emerald-400 font-semibold mb-4">Egresados</p>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight max-w-2xl">
          Resultados que se ven <span className="font-serif italic text-emerald-500">en la hoja de vida</span>
        </h2>
      </Reveal>

      <div className="mt-14 grid sm:grid-cols-2 gap-6">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={(i % 2) * 0.1} className={i === 1 || i === 2 ? "lg:mt-10" : ""}>
            <figure
              data-testid={`testimonial-card-${i}`}
              className="rounded-3xl border border-border bg-card p-8 h-full transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_20px_50px_rgba(16,185,129,0.12)] hover:border-emerald-500/40"
            >
              <Quote className="w-8 h-8 text-emerald-500/40" />
              <blockquote className="mt-4 text-base leading-relaxed">"{t.quote}"</blockquote>
              <figcaption className="mt-7 flex items-center justify-between gap-4 flex-wrap">
                <div className="flex items-center gap-3.5">
                  <img src={t.avatar} alt={t.name} className="w-12 h-12 rounded-full object-cover border-2 border-emerald-500/40" loading="lazy" />
                  <div>
                    <p className="font-semibold text-sm">{t.name}</p>
                    <p className="text-xs text-muted-foreground mt-0.5">{t.role}</p>
                  </div>
                </div>
                <span className="inline-flex items-center gap-1.5 rounded-full bg-emerald-500/10 border border-emerald-500/30 text-emerald-600 dark:text-emerald-400 text-[11px] font-semibold px-3.5 py-1.5">
                  <TrendingUp className="w-3.5 h-3.5" />
                  {t.metric}
                </span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
